export * from './message.enum';
export * from './message.interface';
export * from './message.service';



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/core/message/shared/index.ts